import { useSelector } from "react-redux";
import PermissionDenied from "../../../components/PermissionDenied";
import Sites from "../../../components/Sites";

export default function ClientSite2() {
    const { user_data } = useSelector(state => state.user);

    if (user_data?.role && user_data?.permissions && !user_data?.permissions?.includes('Sites')) {
        return (
                <PermissionDenied title="You don't have permission to access this page" />
            )
        }

    return (<>
        <Sites title={'company'} />
    </>)
}